const INITIAL_STATE = {
    list: {}
};
const cartReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        default: return state;
    }
};

export default cartReducer;